import { render, staticRenderFns } from "./ImportantsSection.vue?vue&type=template&id=0c944958&scoped=true"
import script from "./ImportantsSection.vue?vue&type=script&lang=js"
export * from "./ImportantsSection.vue?vue&type=script&lang=js"
import style0 from "./ImportantsSection.vue?vue&type=style&index=0&id=0c944958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c944958",
  null
  
)

export default component.exports